<template>
  <LayoutBasic
    :showLinksMenu="true"
    :linksMenu="linksMenu"
  >
    <!-- Título del drawer -->
    <template v-slot:title>
      <v-list-item @click="$router.push('/')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold"
            >Inicio</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <!-- Título principal -->
    <template v-slot:navigation-title>Compras</template>

    <!-- DESKTOP: lista lateral (solo visible en desktop) -->
    <template v-slot:navigation-after-links>
  
    </template>

    <!-- Contenido principal -->
    <template v-slot:vista-previa>
      <router-view />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "ComprasEmpresaLayout",
  components: { LayoutBasic },
  data() {
    return {
      mobileTab: null,
       linksMenu: [
        { name: "Facturas", route_name: "pos.compra.factura", icon: "mdi-file-document" },
        { name: "Remitos", route_name: "pos.comprasRemitoListado", icon: "mdi-truck-delivery-outline" },
      ],
    };
  },
};
</script>
